import { connect } from 'react-redux';
import PerformaceSeeMore, {
	DispatchPropsType,
	MapStateType,
} from '../organisms/Performance/SeeMore';
import { Instances } from '../../../constants';
import { TimeRangeFilterType } from '../../../interface';
import {
	changeFilters,
	makeSelectFilters,
	makeSelectInProgress,
	makeSelectObject,
	requestObject,
} from '../../../store/Object';
import {
	changeFilters as objectsChangeFilters,
	changeOffset,
	changeSearchStr,
	makeSelectCount,
	makeSelectObjectsArray,
	makeSelectOffset,
	requestObjects,
} from '../../../store/Objects';
import { IStateType } from '../../../store/models/root.interface';
import withImmutablePropsToJS from 'with-immutable-props-to-js';

const mapStateToProps = (state: IStateType) => ({
	inProgress: makeSelectInProgress(Instances.performanceTabular)(state),
	data: makeSelectObject(Instances.performanceTabular)(state) || [],
	filters: makeSelectFilters(Instances.performance)(state),
	page: makeSelectOffset(Instances.performanceDetailed)(state),
	total: makeSelectCount(Instances.performanceDetailed)(state),
	tableData: makeSelectObjectsArray(Instances.performanceDetailed)(state),
});

const mapDispatchToProps = (dispatch: any) => ({
	onLoad: (filter: TimeRangeFilterType) => {
		dispatch(
			requestObject(Instances.performanceTabular, undefined, filter)
		);
		dispatch(
			requestObjects(Instances.performanceDetailed, filter, {
				searchTerm: 'sender',
				property: 'senders',
			})
		);
	},
	onFilterChange: (filter: TimeRangeFilterType) => {
		dispatch(changeFilters(Instances.performance, filter));
		dispatch(changeFilters(Instances.performanceTabular, filter));
		dispatch(objectsChangeFilters(Instances.performanceDetailed, filter));
	},
	onSearchStrChange: (searchStr?: string) =>
		dispatch(
			changeSearchStr(Instances.performanceDetailed, searchStr || '')
		),
	onPaginate: () => dispatch(changeOffset(Instances.performanceDetailed)),
});

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(PerformaceSeeMore));
